import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Homepage from "./homepage/Homepage";
import SessionTicket from "./SessionTicket/SessionTicket";
import SocScreen from "./SocScreen/SocScreen";
import Error404 from "./404Error/404Error";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/station-detail" element={<Homepage />} />
        <Route path="/get-charging-soc" element={<SocScreen />} />
        <Route path="/transaction-detail" element={<SessionTicket />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Router>
  );
}

export default App;
